<template>
  <div>
    <Top></Top>
    <div class="w main">
      <div class="search">
        <div class="title">レート 折れ線グラフ</div>
        <el-date-picker
          v-model="value2"
          type="month"
          placeholder="选择月"
          style="margin-left: 100px"
        >
        </el-date-picker>
        <div class="fr btn">
          <button @click="selectRq" :class="{ cur: isBgc == true }">
            七天
          </button>
          <button @click="selectRq" :class="{ cur: isBgc == false }">
            近一月
          </button>
        </div>
      </div>
      <div id="map" style="width: 100%; height: 500px"></div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {
      isBgc: true,
      value2: "",
      value1: 1,
    };
  },
  components: {
    Top,
    Foot,
  },
  created() {},
  mounted() {
    this.getMap();
  },
  methods: {
    getMap() {
      var myChart = this.$echarts.init(document.getElementById("map"));
      let echartObj = {
        color: ["#333"],
        title: {
          text: "レート 元/円",
          left: "100",
        },
        // tooltip: {

        //   axisPointer: {
        //     type: "line",
        //     show: true,
        //   },
        //   formatter: function (params) {
        //     let tip = "";
        //     for (let i = 0; i < params.length; i++) {
        //       tip +=
        //         "更新时间<br>" +
        //         params[i].name +
        //         " : 13.30<br>" +
        //         "汇率 元/円 : " +
        //         params[i].value;
        //     }
        //     return tip;
        //   },
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (params) {
            let tip = "";
            for (let i = 0; i < params.length; i++) {
              tip +=
                "更新時間<br>" +
                params[i].name +
                " : 13.30<br>" +
                "レート 元/円 : " +
                params[i].value +
                "円";
            }
            return tip;
          },
        },
        xAxis: {
          type: "category",
          data: [
            "2020-08-1",
            "2020-08-2",
            "2020-08-3",
            "2020-08-4",
            "2020-08-5",
            "2020-08-6",
            "2020-08-7",
            "2020-08-8",
            "2020-08-9",
            "2020-08-10",
            "2020-08-11",
            "2020-08-12",
            "2020-08-13",
            "2020-08-14",
            "2020-08-15",
            "2020-08-16",
            "2020-08-17",
            "2020-08-18",
            "2020-08-19",
            "2020-08-20",
            "2020-08-21",
            "2020-08-22",
            "2020-08-23",
            "2020-08-24",
            "2020-08-25",
            "2020-08-26",
            "2020-08-27",
            "2020-08-28",
            "2020-08-29",
            "2020-08-30",
            "2020-08-31",
            "2020-08-32",
          ],
        },
        yAxis: {
          type: "value",
          scale: true,
          min: "15",
        },
        series: [
          {
            name: "レート/日元",
            type: "line",
            data: [
              "16.91",
              "17.71",
              "16.50",
              "16.34",
              "16.78",
              "16.52",
              "16.11",
              "19.22",
              "16.91",
              "17.71",
              "16.50",
              "16.34",
              "16.78",
              "16.52",
              "16.11",
              "19.22",
              "16.91",
              "17.71",
              "16.50",
              "16.34",
              "16.78",
              "16.52",
              "16.11",
              "19.22",
              "16.91",
              "17.71",
              "16.50",
              "16.34",
              "16.78",
              "16.52",
              "16.11",
              "19.22",
            ],
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.5)",
            },
            symbol: "circle", //是否显示实心的折线圆点
            itemStyle: {
              normal: {
                color: "#f3c622", //折线点的颜色
                lineStyle: {
                  color: "#ddd", //折线的颜色
                },
                label: { show: true }, //是否在折线点上显示数字
                textStyle: {
                  //数值样式
                  color: "#000",
                  fontSize: 16,
                },
              },
            },
            // itemStyle: {
            //   //上方显示数值
            //   color: "pink",
            //   normal: {
            //     label: {
            //       show: true, //开启显示
            //       position: "top", //在上方显示
            //       textStyle: {
            //         //数值样式
            //         color: "#000",
            //         fontSize: 16,
            //       },
            //     },
            //   },
            // },
          },
        ],
      };
      myChart.setOption(echartObj);
    },
    selectRq() {
      this.isBgc = !this.isBgc;
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  border: 1px solid #ccc;
  margin: 30px auto;
}
.search {
  margin: 30px 0;
  padding: 20px;
  font-size: 20px;
  border-bottom: 1px solid #ccc;
  .title {
    text-align: center;
    font-size: 30px;
    line-height: 50px;
    // font-weight: 700;
  }
  .btn {
    margin-right: 100px;
    button {
      width: 200px;
      height: 40px;
      border: 1px solid #ccc;
      background-color: #fff;
      font-size: 20px;
      &:nth-child(1) {
        border-right: 0;
      }
    }
    .cur {
      background: #f3c622;
      color: #fff;
    }
  }
}
</style>